
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal-medicine",
      function () {
        return require("private-next-pages/internal-medicine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal-medicine"])
      });
    }
  